const conditionAlertList = {
    bindings: {
      selection: '<',
      settings: '<',
      criteria: '<',
      filters: '<',
      area: '<',
      gridlet: '<',
    },
    templateUrl: '/modules/gridlets/condition-alert-list/condition-alert-list.html',
    controller: 'ConditionAlertListController',
  };
  
  angular
    .module('gridlets.module')
    .component('conditionAlertList', conditionAlertList);